import React, { PureComponent } from 'react';

import { Icon } from '@lumapps/lumx/react';
import { mdiMessageTextOutline, mdiArrowRight } from '@lumapps/lumx/icons';

/**
 * Display a conversation block from a channel.
 */
export class ConversationBlock extends PureComponent {
    constructor(props) {
        super(props);

        this.openConversation = this.openConversation.bind(this);
    }

    /**
     * Open the channel in a new tab.
     */
    openConversation() {
        const { conversation } = this.props;

        window.open(conversation.channelUrl, '_blank');
    }

    render() {
        const { conversation } = this.props;

        return (
            <div key={conversation.id} className="conversation-block" onClick={this.openConversation}>
                <div className="conversation-block__icon">
                    <Icon icon={mdiMessageTextOutline} />
                </div>

                <div className="conversation-block__title">
                    <span>{conversation.name}</span>
                </div>

                <div className="conversation-block__action">
                    <Icon icon={mdiArrowRight} />
                </div>
            </div>
        );
    }
}
